if (!window.Promise) {
  window.Promise = require('promise-polyfill')
}


// WEBPACK FOOTER //
// ./polyfills.js